export default __webpack_public_path__ + "278a3a7b93c0599dd0de95dd71e0fa77.svg";